<div class="mytc-logo-container">
  <img class="mytc-logo logo-purple" src="./assets/img/mytc-logo-purple.png" />
</div>
<div>
  @if (showSignInButton) {
    <button class="sign-in-button" (click)="signIn()">
      {{ 'auth.login' | translate }}
    </button>
  } @else {
    <img class="tc-logo" src="./assets/img/tc-logo-purple-sm.png" alt="TC Logo" />
  }
</div>
